var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { useQuery } from '@apollo/client';
import { getAllMarketCodes, getCurrentMarketTemplateLocales } from 'shared/domains/markets/config';
import { InsightsComposersQueryDocument } from './InsightsComposersQuery.gql';
export const useGetComposers = () => {
    const templatesMarketLocalCodes = getCurrentMarketTemplateLocales().map(({ languageCode }) => languageCode);
    const marketCodes = getAllMarketCodes();
    const filters = {
        marketCode: { in: marketCodes },
        templates: { marketLocaleCode: { in: templatesMarketLocalCodes } },
        enabled: { eq: true },
    };
    const _a = useQuery(InsightsComposersQueryDocument, { variables: { filters } }), { data } = _a, rest = __rest(_a, ["data"]);
    const { composers = [] } = data || {};
    const normalizedComposers = composers
        .filter((composer) => { var _a; return (_a = composer.metadata[0]) === null || _a === void 0 ? void 0 : _a.name; })
        .map((composer) => {
        var _a;
        return ({
            id: composer.id,
            title: (_a = composer.metadata[0]) === null || _a === void 0 ? void 0 : _a.name,
        });
    })
        .sort((a, b) => a.title.localeCompare(b.title));
    return Object.assign({ composers: normalizedComposers }, rest);
};
